import { Outlet } from 'react-router-dom';
import AdminLogin from '../pages/AdminLogin';

export default function PrivateRoute() {
  const isAuthenticated = !!sessionStorage.getItem('udanchu_admin_key');
  return isAuthenticated ? <Outlet /> : <AdminLogin />;
}
